import icons from '../../utils/icons';

const Success = () => {
    return <img src={icons.success} alt="" />;
};

export default Success;
